import { AxiosInstance } from "axios"
import { Device, DeviceType } from "../../../../entities/devices/deviceTypes"

type AllDevicesParams = Readonly<{
    serviceCenterId: number
    type?: DeviceType
}>

export type DevicesServiceCenterResponse = Readonly<{
    devices: Device[]
}>

export enum ServiceCenterDevicesQuery {
    DEVICES = "devices-for-service-center",
}

export async function fetchServiceCenterDevices(
    { serviceCenterId, type }: AllDevicesParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DevicesServiceCenterResponse> {
    const { data } = await axios.get(`/serviceCenters/${serviceCenterId}/devices?type=${type}`, {
        signal,
    })
    return data
}
